import React from "react";
import MainLayout from "../../layouts/MainLayout";
import "./styles.css"
import HeaderSection from "./section/HeaderSection";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import DescriptionSection from "./section/DescriptionSection";

const Home = () => {
    const [t] = useTranslation("common");

    return (
        <MainLayout>
            <Helmet>
                <title>{t("seo.home.title")}</title>
                <meta name='description' content={t("seo.home.description")} />
            </Helmet>
            <div className="backgroundImgHome">
                <HeaderSection />
                <DescriptionSection />
            </div>
        </MainLayout>
    );
}

export default Home;
